import { render, staticRenderFns } from "./UsersChart.vue?vue&type=template&id=bdad7f82&"
import script from "./UsersChart.vue?vue&type=script&lang=ts&"
export * from "./UsersChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports